export const environment = {
  env: 'prod',
  apiUrl: 'https://api.theprodprocess.com/',
  backendUrl: 'https://portal.theprodprocess.com/',
  preBidUrl: 'https://prebid.thelift.mx/',
  production: true,
  invalidEmailDomain: ['@mailinator.com']
};

export const cineburo_environment = {
  env: 'prod',
  apiUrl: 'https://api.cineburo.com/',
  backendUrl: 'http://portal.cineburo.com/',
  preBidUrl: 'https://prebid.cineburo.com/',
  production: true,
  invalidEmailDomain: ['@mailinator.com']
};

export const ent_environment = {
  env: 'prod',
  apiUrl: 'https://entapi.thelift.mx/',
  backendUrl: 'https://entportal.thelift.mx/',
  preBidUrl: 'https://entprebid.thelift.mx/',
  production: true
};


// WEBPACK FOOTER //
// ./src/environments/environment.prod.ts